export function anchorScroll() {

    $(".anchor-link").on("click", function (event) {
        event.preventDefault();
        const id = $(this).attr("href");
        const top = $(id).offset().top;


        $("body, html").animate({scrollTop: top - ($(".main-header").height() + 10)}, 600);
    });

    
}


// WEBPACK FOOTER //
// ./assets/js/modules/anchor-scroll.js